// extracted by mini-css-extract-plugin
module.exports = {"center":"RecoveryEntry-RecoveryEntry-center-05380165","label":"RecoveryEntry-RecoveryEntry-label-841ab7fd"};